"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, Search, Bell, Videotape, MessageCircle } from "lucide-react";
import {
  homePage,
  notificationPage,
  clipsPage,
  chatsPage,
} from "@/constants/page";
import { useSelector } from "react-redux";
import { RootState } from "@/lib/features/store";
import { useAuth } from "@/contexts/authContext";

const BottomNav = () => {
  const { isAuthenticated } = useAuth();
  const pathname = usePathname();
  const unreadCount = useSelector(
    (state: RootState) => state.notification.count
  );
  const chatCount = useSelector(
    (state: RootState) => state.notification.chatCount
  );

  const normalize = (path: string) => {
    const trimmed = path.replace(/\/+$/, "");
    return trimmed === "" ? "/" : trimmed;
  };

  const currentPath = pathname ? normalize(pathname) : "";
  if (!isAuthenticated) return null;
  return (
    <div className="md:hidden w-full sticky bottom-0 left-0 z-30 backdrop-blur-2xl flex justify-around py-4 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      {/* Home Page Link */}
      <Link href={homePage.to}>
        <div
          className={`flex flex-col items-center px-3 py-2 rounded-full transition-colors ${
            normalize(homePage.to) === currentPath
              ? "bg-primary/10 text-primary"
              : "hover:bg-muted/40"
          }`}
        >
          <Home className="h-6 w-6" />
        </div>
      </Link>
      <Link href={clipsPage.to}>
        <div
          className={`flex flex-col items-center px-3 py-2 rounded-full transition-colors ${
            normalize(clipsPage.to) === currentPath
              ? "bg-primary/10 text-primary"
              : "hover:bg-muted/40"
          }`}
        >
          <Videotape className="h-6 w-6" />
        </div>
      </Link>

      {/* Messages Page Link */}
      <Link href={chatsPage.to}>
        <div
          className={`flex flex-col items-center px-3 py-2 rounded-full transition-colors ${
            normalize(chatsPage.to) === currentPath ||
            currentPath.startsWith("/chats/")
              ? "bg-primary/10 text-primary"
              : "hover:bg-muted/40"
          }`}
        >
          <div className="relative">
            <MessageCircle className="h-6 w-6" />
            {chatCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-gradient-to-r from-[#e0aa3e] to-[#f9f295] text-black text-xs rounded-full h-4 w-4 flex items-center justify-center">
                {chatCount}
              </span>
            )}
          </div>
        </div>
      </Link>

      {/* search Page Link */}
      <Link href="/search">
        <div
          className={`flex flex-col items-center px-3 py-2 rounded-full transition-colors ${
            normalize("/search") === currentPath
              ? "bg-primary/10 text-primary"
              : "hover:bg-muted/40"
          }`}
        >
          <Search className="h-6 w-6" />
        </div>
      </Link>

      {/* Notifications Page Link */}
      <Link href={notificationPage.to}>
        <div
          className={`flex flex-col items-center px-3 py-2 rounded-full transition-colors ${
            normalize(notificationPage.to) === currentPath
              ? "bg-primary/10 text-primary"
              : "hover:bg-muted/40"
          }`}
        >
          <div className="relative">
            <Bell className="h-6 w-6" />
            {unreadCount > 0 && (
              <span className="absolute -top-3 -right-2 bg-gradient-to-r from-[#e0aa3e] to-[#f9f295] text-black text-xs rounded-full h-6 w-6 flex items-center justify-center">
                <span className="text-[10px] text-center">
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              </span>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BottomNav;
